import * as React from 'react'
import { Button, Col, Container, Row} from 'reactstrap'
import { getConfiguration } from '../../utils'
import { UnsubscribeLayoutAttributes } from '../constants'
import { HeaderComponent } from './headerComponent'

export const Resubscribe = ({data}) =>
  <div>
    <HeaderComponent data={data} />
    <Container>
      <Row>
        <Col>
            <header className="unsub-page-header text-center"
              dangerouslySetInnerHTML={{
                  __html: getConfiguration(data, UnsubscribeLayoutAttributes.ResubscribeHeaderText),
                }}>
            </header>
        </Col>
      </Row>
        <div>
          <Row className="schedule-row">
            <Col>
            <div className="text-center"
                dangerouslySetInnerHTML={{
                  __html: getConfiguration(data, UnsubscribeLayoutAttributes.ResubscribeHeaderDescription),
                }}>
              </div>
            </Col>
          </Row>
          <Row className="schedule-row">
            <Col className="text-center">
              <Button disabled={true}
                style={{backgroundColor: getConfiguration(data,
                UnsubscribeLayoutAttributes.ResubscribeButtonColor, '')}}>
                {getConfiguration(data, UnsubscribeLayoutAttributes.ResubscribeButtonText)}
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
